import PropTypes from "prop-types"
import React, { useState } from "react"

import Button from "src/components/Button"

import EditPendingReservationModal from "./EditPendingReservationModal"

const EditPendingReservation = ({
  reservationId,
  checkInDate,
  checkOutDate,
  electricProductId,
  electricProducts,
  storageProductId,
  storageProducts,
  ratePreservationEnabled,
  hasPreservedRates,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Button
        onClick={() => setIsOpen(true)}
        icon="icon-edit-square"
        variant="secondary"
      >
        Edit
      </Button>
      <EditPendingReservationModal
        reservation={{
          id: reservationId,
          checkInDate,
          checkOutDate,
          electricProductId,
          storageProductId,
        }}
        electricProducts={electricProducts}
        storageProducts={storageProducts}
        ratePreservationEnabled={ratePreservationEnabled}
        hasPreservedRates={hasPreservedRates}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  )
}

EditPendingReservation.propTypes = {
  reservationId: PropTypes.number.isRequired,
  checkInDate: PropTypes.string.isRequired,
  checkOutDate: PropTypes.string.isRequired,
  electricProductId: PropTypes.string,
  electricProducts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  storageProductId: PropTypes.string.isRequired,
  storageProducts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  ratePreservationEnabled: PropTypes.bool.isRequired,
  hasPreservedRates: PropTypes.bool.isRequired,
}

export default EditPendingReservation
